import ClipboardJS from "clipboard";

export function initializeSocialButtonShare(reset) {
    // Facebook share
    $('.btn-facebook-share').click(function (e) {
        e.preventDefault();
        let width = 640;
        let height = 450;
        let url = $(this).data('url');
        let left = ($(window).width() / 2) - (width / 2);
        let top = ($(window).height() / 2) - (height / 2);
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(url), 'FacebookShareWindow', 'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left + ',menubar=no,toolbar=no,resizable=yes,scrollbars=yes');
        return false;
    });

    // Twitter share
    $('.btn-twitter-share').click(function (e) {
        e.preventDefault();
        let width = 640;
        let height = 450;
        let url = $(this).data('url');
        let title = $(this).data('title');
        let left = ($(window).width() / 2) - (width / 2);
        let top = ($(window).height() / 2) - (height / 2);
        window.open('https://twitter.com/intent/tweet?url=' + encodeURI(url) + '&text=' + encodeURI(title), 'TwitterShareWindow', 'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left + ',menubar=no,toolbar=no,resizable=yes,scrollbars=yes');
        return false;
    });

    // LinkedIn share
    $('.btn-linkedin-share').click(function (e) {
        e.preventDefault();
        let width = 640;
        let height = 450;
        let url = $(this).data('url');
        let title = $(this).data('title');
        let left = ($(window).width() / 2) - (width / 2);
        let top = ($(window).height() / 2) - (height / 2);
        window.open('https://www.linkedin.com/shareArticle?url=' + encodeURI(url) + '&title=' + encodeURI(title), 'LinkedInShareWindow', 'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left + ',menubar=no,toolbar=no,resizable=yes,scrollbars=yes');
        return false;
    });

    if (reset) {
        let clipboardDashboard = new ClipboardJS('.btn-clipboard-dashboard', {
            container: document.getElementById('modal-share')
        });

        clipboardDashboard.on('success', function (e) {
            notify(translate('common.copied_to_clipboard'))
        });
    }

    let clipboardClient = new ClipboardJS('.btn-clipboard');

    clipboardClient.on('success', function (e) {
        notify(translate('common.copied_to_clipboard'))
    });


    const toastTrigger = document.getElementById('liveToastBtn')
    const toastLiveExample = document.getElementById('liveToast')

    if (toastTrigger) {
        const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastLiveExample)
        toastTrigger.addEventListener('click', () => {
            toastBootstrap.show()
        })
    }


    function notify(message) {
        if (typeof toastr !== 'undefined') {
            toastr["success"](message);
        } else {
            Notification.message(
                translate('common.alert'),
                message,
                'success',
                5000
            );
        }
    }
}
